import { render, staticRenderFns } from "./piyasaarastirmagorevlileri.vue?vue&type=template&id=50161fa2&"
import script from "./piyasaarastirmagorevlileri.vue?vue&type=script&lang=js&"
export * from "./piyasaarastirmagorevlileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports